import React, { Component } from 'react'
import { CurrentUserConsumer } from 'providers/CurrentUser'
import ModalContext from 'components/Context/ModalContext'
import Navbar from '../Home/components/NavBar/NavBar'
import YourClass from './pages/YourClass/YourClassContainer'
import YourAccount from './pages/YourAccount/YourAccountContainer'
import SchoolAccount from './pages/SchoolAccount/SchoolAccountContainer'
import Referrals from './pages/Referrals/ReferralsContainer'
import Subscription from './pages/Subscription/SubscriptionContainer'

import { PageWrapper } from './DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class DashboardSettings extends Component {
  isActive (path) {
    return location.pathname.split('/').indexOf(path) !== -1
  }

  getNavbarItems (currentUser) {

    let navbarItems = [
      {
        text: 'Your Class',
        to: `/dashboard/settings/your-class`,
        selected: this.isActive('your-class')
      },
      {
        text: 'Your Account',
        to: `/dashboard/settings/your-account`,
        selected: this.isActive('your-account')
      },
      {
        text: 'Subscription',
        to: `/dashboard/settings/subscription`,
        selected: this.isActive('subscription')
      },
      {
        text: 'Refer a Friend',
        to: `/dashboard/settings/refer`,
        selected: this.isActive('refer')
      }
      // {
      //   text: 'Curriculum',
      //   to: `${match.path}/curriculum`,
      //   selected: this.isActive('curriculum')
      // }
    ]

    if (!currentUser.parent) {
      navbarItems.splice(3, 0, {
        text: 'School Account',
        to: `/dashboard/settings/school-account`,
        selected: this.isActive('school-account')
      })
      navbarItems.pop()
      if (!currentUser.isUnderCustomSubscription) {
        navbarItems.push({
          text: 'Refer a Teacher',
          to: `/dashboard/settings/refer`,
          selected: this.isActive('refer')
        })
      }
    }

    return navbarItems
  }

  render () {
    return (
      <CurrentUserConsumer>
        {currentUser => (
          <PageWrapper key='page-wrapper'>
            <ModalContext.Consumer>
              {modal => (
                <Navbar
                  key='navbar'
                  items={this.getNavbarItems(currentUser)}
                  backLink='/dashboard/classroom'
                  isSettings
                  bgColor={colors.paleBlue}
                  modal={modal}
                />
              )}
            </ModalContext.Consumer>
            { this.props.category === 'your-class' && <YourClass /> }
            { this.props.category === 'your-account' && <YourAccount /> }
            { this.props.category === 'school-account' && <SchoolAccount ambassadorSignUp={this.props.ambassadorSignUp} /> }
            { this.props.category === 'refer' && <Referrals ambassadorSignUp={this.props.ambassadorSignUp} /> }
            { this.props.category === 'subscription' && <Subscription /> }
          </PageWrapper>
        )}
      </CurrentUserConsumer>
    )
  }
}
